import React from "react";
import ReactDOM from "react-dom";
import App from "./app";

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  withRouter,
} from "react-router-dom";

import store from "store";

import { Provider } from "react-redux";

if (process.env.NODE_ENV === "production") {
  window.appConfig = {
    env: "production",
    apiEndpoint: `//${process.env.REACT_APP_SERVER_DOMAIN}/endpoints`,
  };
} else if (process.env.NODE_ENV === "development") {
  window.appConfig = {
    env: "development",
    apiEndpoint: "//localhost:8000/app/endpoints",
  };
}

console.log("appConfig", window.appConfig);

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
